import { doLoginByPassword, doLoginByVerifyCode } from '@/axios/IGetData'
import { setLocalStorageItem } from '@utils/storage'
import router from '@/router/index.js'

export function getUrlParam (queryStr, name) {
  const r = queryStr.match(new RegExp('(^|&)' + name + '=([^&]*)(&|$)'))
  return r && decodeURIComponent(r[2])
}
export function jumpWithQueriesToLogin ($store, cb) {
  const str = window.location.search.substring(1)
  const name = getUrlParam(str, 'u')
  const password = getUrlParam(str, 'p')
  const verificationCode = getUrlParam(str, 'v')
  const Token = getUrlParam(str, 't')

  try {
  if(Token ){
      return
    }
  } catch (error) {
        
  }
    
  if (name && password) {
    doLoginByPassword({ UserId: name, Password: password }, (rs) => {
      $store.dispatch('login', rs.Result)
      cb && cb()
    })
  } else if (name && verificationCode) {
    doLoginByVerifyCode({ UserId: name, VerifyCode: verificationCode }, (rs) => {
      $store.dispatch('login', rs.Result)
      cb && cb()
    })
  } else {
    cb && cb()
  }
}
